import { Navigate } from "react-router-dom";

function AdminRoute({ children }) {

  const token =
    localStorage.getItem("token");

  const role =
    localStorage.getItem("role");

  /* ===============================
     NOT AUTHORIZED
  =============================== */

  if (
    !token ||
    role !== "ROLE_ADMIN"
  ) {

    return (
      <Navigate to="/admin/login" />
    );

  }

  /* ===============================
     AUTHORIZED
  =============================== */

  return children;
}

export default AdminRoute;